import React from 'react';
import { ErrorBoundary } from '@/shared/ui';
import { logger } from '@/shared/lib';

interface ErrorBoundaryProviderProps {
  children: React.ReactNode;
}

export const ErrorBoundaryProvider: React.FC<ErrorBoundaryProviderProps> = ({ children }) => {
  return (
    <ErrorBoundary
      showDetails={import.meta.env.DEV}
      onError={(error, errorInfo) => {
        // Global error logging
        logger.error('Application Error:', error);
        logger.error('Error Info:', errorInfo);
        
        // Here you could integrate with error tracking services like:
        // - Sentry
        // - LogRocket
        // - DataDog
        // - Custom analytics
        
        // Example:
        // if (typeof window !== 'undefined' && window.gtag) {
        //   window.gtag('event', 'exception', {
        //     description: error.message,
        //     fatal: false
        //   });
        // }
      }}
    >
      {children}
    </ErrorBoundary>
  );
};